<template>
  <div>
    <admin-header @menu-toggle="toggleMenu()" />

    <admin-sidebar :closed="isMenuClosed">
      <slot name="sidebar-links"></slot>
    </admin-sidebar>
    <main class="admin-content">
      <div class="container-fluid">
        <slot></slot>
      </div>
    </main>
  </div>
</template>

<script>
import PageSize from 'utils/PageSize';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['type'],
  components: {
    AdminHeader,
    AdminSidebar,
  },
  data() {
    return {
      isMenuClosed: true,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuClosed = !this.isMenuClosed;
    },
  },
  mounted() {
    this.isMenuClosed = PageSize.isMobile();
  },
};
</script>
